/**
 * 汉堡菜单组件
 * 提供移动端汉堡式导航菜单功能
 * 
 * @module common/components/HamburgerMenu
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 确保命名空间存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.common) {
    global.watashi.common = {};
  }

  const common = global.watashi.common;

  /**
   * 汉堡菜单组件
   * @class HamburgerMenu
   * 
   * @example
   * new watashi.common.HamburgerMenu({
   *   container: '#regional_store_query',
   *   hoverClass: 'hover',
   *   configs: [
   *     {
   *       selector: '.regional-store > .g-name',
   *       container: '.regional-store > .g-container'
   *     }
   *   ]
   * });
   */
  common.HamburgerMenu = (function () {
    const defaults = {
      container: '',
      hoverClass: 'hover',
      configs: [],
    };

    /**
     * 创建汉堡菜单实例
     * @param {Object} options - 配置选项
     */
    function HamburgerMenu(options) {
      this.settings = {...defaults, ...options};
      this.init();
    }

    const _hamburger = HamburgerMenu.prototype;

    /**
     * 初始化菜单
     */
    _hamburger.init = function () {
      if (common.exists(this.settings.container)) {
        this.bindEvents();
      }
    };

    /**
     * 绑定事件
     */
    _hamburger.bindEvents = function () {
      const configs = this.settings.configs || [];
      const hoverClass = this.settings.hoverClass;

      configs.forEach(config => {
        const buttons = document.querySelectorAll(config.selector);
        buttons.forEach(button => {
          common.registerEvent(button, 'click', common.toggleMenu.bind(this, {
            nameSelector: config.selector,
            containerSelector: config.container,
            hoverClass: hoverClass,
          }));
        });
      });
    };

    return HamburgerMenu;
  })();

})(typeof window !== "undefined" ? window : this);
